module.exports = __webpack_public_path__ + "img/mor.a512a74c.png";